import { useEffect, useRef } from "react";

const SummernoteEditor = ({ value, onChange, height = 300, disabled = false }) => {
  const editorRef = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const $ = window.jQuery;
    const $editor = $(editorRef.current);

    $editor.summernote({
      height,
      placeholder: "Write email body...",
      tooltip: false,
      toolbar: [
        ["style", ["bold", "italic", "underline", "clear"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["insert", ["link", "picture"]],
        ["view", ["fullscreen", "codeview"]],
      ],
      callbacks: {
        onChange: (contents) => onChangeRef.current(contents),
      },
    });

    $editor.summernote("code", value || "");

    return () => {
      $editor.summernote("destroy");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const $ = window.jQuery;
    const $editor = $(editorRef.current);
    if (disabled) {
      $editor.summernote("disable");
    } else {
      $editor.summernote("enable");
    }
  }, [disabled]);

  return <div ref={editorRef} />;
};

export default SummernoteEditor;